import React from 'react';
import { faCheckCircle as faCheckCircleSelected } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle as faCheckCircleNotSelected } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './styles.scss';

interface Props {
  label: string;
  selected: boolean;
}

const CreateGroupBreadcrumbItem: React.FC<Props> = ({ label, selected = false }) => (
  <div className="create-group-breadcrumb-item">
    {selected ? (
      <FontAwesomeIcon icon={faCheckCircleSelected} color="#8ac731" size="lg" />
    ) : (
      <FontAwesomeIcon icon={faCheckCircleNotSelected} color="#f5f5f5" size="lg" />
    )}
    <span className="label">{label}</span>
  </div>
);

export default CreateGroupBreadcrumbItem;
